import { createSelector } from '@reduxjs/toolkit';

import { StoreState } from '../types';

import { SearchState } from './types';

export const getSearchState = (state: StoreState): SearchState => state.search;

export const getSearchFiltersCount = createSelector(
  getSearchState,
  bookings => +(!!bookings.from && !!bookings.to),
);
